import {useState} from "react";
import {RpcState} from "../RpcState";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {useRpcSender} from "../RpcSender";
import {VerificationRequest, VerificationResponse} from "../../provider_api";

/**
 * This actually works for three different actions, all of which are typed with
 * <VerificationRequest, VerificationResponse>. They are:
 * 
 * - set_contact_method
 * - check_verification_code
 * - send_verification
 */
export const useVerificationRpc = () => {

  const {setProvider, setBusiness} = useProviderProfile();
  const rpcSender = useRpcSender();

  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})

  const send = (method: 'set_provider_contact_method' | 'check_verification_code' | 'send_verification',
                request: VerificationRequest,
                onSuccess?: () => void) => {

    setRpcState({state: 'pending'})

    rpcSender.send(method, VerificationRequest.encode(request).finish())
        .then(resp => {
          let response = VerificationResponse.decode(resp);

          if (!response.okay) {
            setRpcState({state: 'error', message: response.error})
            return;
          }

          setRpcState({state: 'success'})
          setProvider(response.updatedProvider);
          response.updatedBusiness && setBusiness(response.updatedBusiness);
          onSuccess && onSuccess();

        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error. Please try again later'})
        });
  }

  return {rpcState, send}
}